export default __webpack_public_path__ + "assets/front/scss/affichage-mosaic.a288c80e68871e7b910bc7f548177f5c.css";